import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

export function AnimatedNumber({ value, prefix = "", suffix = "", decimals = 0, className = "" }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => {
    const fixed = decimals > 0 ? v.toFixed(decimals) : Math.round(v).toString();
    const parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${prefix}${parts.join(".")}${suffix}`;
  });
  useEffect(() => {
    const controls = animate(mv, value, { duration: 1.1, ease: "easeOut" });
    return controls.stop;
  }, [value, mv]);
  return <motion.span className={className}>{rounded}</motion.span>;
}
